/**
 *
 * @param {String} url
 * @param {Boolean=} isFullUrl
 */

export function redirect(url, isFullUrl) {
  if (isFullUrl) {
    window.location = url;
  } else {
    window.location.href = url;
  }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/location.js
 **/